import {
  get,
  map,
  isEmpty,
  find,
  filter,
  maxBy,
  forEach,
  size,
  findIndex,
  remove,
  concat,
  some,
  reduce,
} from 'lodash-es';

import uuidv4 from 'uuid/v4';
import {
  formatCoveragesCurrencies,
  isNotEqualToZero,
  getTaeaFromOffers,
  getFeeFromOffers,
  getFullNameParty,
  getPartyGenderLabel,
} from './utils';
import { formatAmountCurrency } from '../../../../Utils/Utils';

/**
 * get data offer
 * @param {*} idQuestionnaire
 * @param {*} idPart
 * @param {*} codeQuestionnaire
 * @param {*} parties
 * @param {*} quotation
 * @param {*} product
 * @param {*} titlePart
 * @param {*} part
 * @param {*} packageEligible
 * @param {*} codeCommercialProduct
 * @param {*} strings
 * @param {Array<object>} loans
 */
export const getDataOffer = ({
  codeQuestionnaire,
  parties,
  quotation,
  product,
  titlePart,
  part,
  packageEligible,
  codeCommercialProduct,
  strings,
  loans,
}) => {
  try {
    /**
     * get party
     * @param {*} ref
     */
    const getParty = ref => {
      const party = find(parties, { ref });
      return {
        ...party,
        gender: getPartyGenderLabel(get(party, 'gender'), strings),
        fullName: getFullNameParty(get(party, 'ref'), parties, strings),
      };
    };

    /**
     * get name coverage by code
     * @param {*} code
     */
    const getNameCoverageByCode = code => {
      // TODO: call get /product/ID
      const coverages = [];
      forEach(get(product, 'item_descriptors', []), item => {
        forEach(get(item, 'coverages', []), coverage => {
          coverages.push(coverage);
        });
      });
      const itemDescriptor = find(coverages, { code });
      let name = get(itemDescriptor, 'name');
      if (name) {
        return name;
      }
      name = get(find(get(product, 'coverages'), { code }), 'name');
      return name || code;
    };

    const offers = remove(
      map(get(quotation, 'offer', []), offer => {
        const productCode = get(offer, 'product.code');
        const packageCode = get(offer, 'package.code');
        const results = get(part, 'results');
        return findIndex(
          results,
          result => get(result, 'product') === productCode && get(result, 'package') === packageCode
        ) > -1
          ? offer
          : null;
      }),
      n => !isEmpty(n)
    );

    /**
     * get Discounts
     */
    const getDiscounts = () => {
      const discounts = map(offers, offer => {
        const packageCode = get(offer, 'package.code');
        return {
          ref: packageCode,
          value: get(offer, 'premium.total_discounts'),
        };
      });

      return discounts || [];
    };
    const covereds = [];
    const subscriber = getParty(get(quotation, 'subscriber.ref'));
    covereds.push(subscriber);
    forEach(get(quotation, 'covereds', []), covered => {
      const partyRef = get(covered, 'party.ref');
      if (partyRef !== get(subscriber, 'ref')) {
        const party = getParty(partyRef);
        covereds.push(party);
      }
    });

    const add2Float = (float1, float2) => (parseFloat(float1) + parseFloat(float2)).toFixed(2);

    /**
     * get coverages By covered
     */
    const getCoveragesByCovered = ({ coveredOffer, ref, offer }) => {
      //
      let total = 0;
      let subTotal = 0;
      let reduction = 0;
      //
      let coverages = map(get(coveredOffer, 'coverages'), coveragesItem => {
        const value = add2Float(
          get(coveragesItem, 'premium.total_premium', '0'),
          get(coveragesItem, 'premium.total_tax', '0')
        );
        // subTotal
        subTotal = add2Float(subTotal, value);
        // reduction
        reduction = add2Float(reduction, get(coveragesItem, 'premium.total_discounts', '0'));
        // total
        total = add2Float(total, get(coveragesItem, 'premium.total', '0'));
        return {
          name: getNameCoverageByCode(get(coveragesItem, 'coverage.code')),
          value,
        };
      });
      // remove empty value
      // coverages = remove(coverages, ({ value }) => {
      //   return value !== '0.00';
      // });
      // HACK: add coverages premiums if covered === subscriber
      if (ref === get(subscriber, 'ref')) {
        forEach(get(offer, 'coverages', []), coverage => {
          const value = add2Float(get(coverage, 'premium.total_premium', '0'), get(coverage, 'premium.total_tax', '0'));
          // subTotal
          subTotal = add2Float(subTotal, value);
          // reduction
          reduction = add2Float(reduction, get(coverage, 'premium.total_discounts', '0'));
          // total
          total = add2Float(total, get(coverage, 'premium.total', '0'));
          coverages.push({
            name: getNameCoverageByCode(get(coverage, 'coverage.code')),
            value: value,
          });
        });
      }
      //
      // add `coverage_amount` object to coverages
      //
      const coveragesFiltred = filter(
        get(coveredOffer, 'coverages'),
        coveragesItem => !isEmpty(get(coveragesItem, 'coverage_amount'))
      );
      const coveragesMount = map(coveragesFiltred, coveragesItem => {
        const coverageAmount = get(coveragesItem, 'coverage_amount');
        const label = get(coverageAmount, 'label', '');
        const amount = get(coverageAmount, 'amount', 0);
        const coverageAmountObject = { name: label, type: 'subtotal', value: amount };
        return coverageAmountObject;
      });
      if (size(coveragesMount) > 0) {
        // add coverage_amount object to coverages
        coverages = reduce(
          coverages,
          (results, coverageItem, index) => {
            let result = concat(results, [coverageItem]);
            if (coveragesMount[index]) {
              result = concat(result, [coveragesMount[index]]);
            }
            return result;
          },
          []
        );
      }
      // sub total
      coverages.push({
        name: get(strings, 'editsalesroute.podium.subTotal.label', 'Sous total'),
        type: 'subtotal',
        value: subTotal,
      });
      // reduction
      // if reduction == 0.0 then do not display
      if (isNotEqualToZero(reduction)) {
        coverages.push({
          name: get(strings, 'editsalesroute.podium.discount.label', 'Réduction'),
          type: 'discount',
          value: reduction,
        });
      }
      // total
      coverages.push({
        name: get(strings, 'editsalesroute.podium.total.label', 'Total'),
        type: 'total',
        value: total,
      });
      //
      return formatCoveragesCurrencies(coverages);
    };

    /**
     * get Packages By Covered
     * @param {*} covered
     */
    const getPackagesByCovered = covered => {
      try {
        const ref = get(covered, 'ref');
        const packages = [];

        forEach(offers, offer => {
          const offerCovereds = get(offer, 'covereds', []);
          const coveredOffers = filter(offerCovereds, { party: { ref } });
          forEach(coveredOffers, coveredOffer => {
            let value = add2Float(
              get(coveredOffer, 'premium.total_premium', '0'),
              get(coveredOffer, 'premium.total_tax', '0')
            );
            // HACK: add coverages premiums if covered === subscriber
            if (ref === get(subscriber, 'ref')) {
              forEach(get(offer, 'coverages', []), coverage => {
                const valueCoverage = add2Float(
                  get(coverage, 'premium.total_premium', '0'),
                  get(coverage, 'premium.total_tax', '0')
                );
                value = add2Float(value, valueCoverage);
              });
            }
            packages.push({
              ref: get(offer, 'package.code'),
              value: formatAmountCurrency(value),
              coverages: getCoveragesByCovered({ coveredOffer, ref, offer }),
            });
          });
        });
        return packages;
      } catch (e) {
        return undefined;
      }
    };

    let data = [];

    // add covered
    // if the product kind is a loan insurance
    const isLoanKind = product.hasOwnProperty('loan_configuration');
    // then modify label
    if (isLoanKind) {
      forEach(covereds, covered => {
        data.push({
          id: uuidv4(),
          label: get(
            strings,
            'editsalesroute.podium.loan.total.label',
            'Total des cotisations pour la durée du contrat'
          ),
          packages: getPackagesByCovered(covered),
        });
      });
    } else {
      forEach(covereds, covered => {
        data.push({
          id: uuidv4(),
          label: get(covered, 'fullName'),
          packages: getPackagesByCovered(covered),
        });
      });
    }

    // HACK: remove covered if value = 0 (not eligible)
    data = remove(data, ({ packages = [] }) => {
      let p = [...packages];
      p = remove(p, ({ value }) => value !== '0.00');
      return p.length !== 0;
    });

    /**
     * Add discount
     */
    const discounts = getDiscounts();
    if (discounts.length > 0 && some(discounts, discount => discount.value !== '0')) {
      data.push({
        id: uuidv4(),
        label: get(strings, 'editsalesroute.podium.discount.label', 'Réduction totale'),
        type: 'discount',
        packages: getDiscounts(),
      });
    }
    /**
     * Add TAEA and FEE if product kind is loan insurance
     */
    // if the product kind is a loan insurance
    // then add FEES data
    if (isLoanKind) {
      // add FEES
      const fees = getFeeFromOffers(offers, strings);
      fees?.forEach(fee => data.push(fee));
    }

    /**
     * Add Total
     */
    // TODO: Add 2 kinds of total if product is a loan insurance (see issue #20085)
    const lastItemData = {
      id: uuidv4(),
      label: get(strings, 'editsalesroute.podium.total.label', 'Coût total'),
      type: 'total',
      packages: map(offers, offer => {
        const packageCode = get(offer, 'package.code');
        const value = get(offer, 'premium.total');
        return {
          ref: packageCode,
          value,
          offerRef: offer?.ref,
        };
      }),
    };

    /**
     * sort Default
     * @param {*} a
     * @param {*} b
     */
    const sortDefault = (a, b) => {
      try {
        const valueA = Number(get(a, 'value', 0));
        const valueB = Number(get(b, 'value', 0));
        if (valueA > valueB) return 1;
        if (valueA < valueB) return -1;
        return 0;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`sortDefault: ${e.stack}`);
      }
      return 0;
    };

    /**
     * default sort offers by price
     */
    const packagesSorted = [...get(lastItemData, 'packages', [])].sort(sortDefault);

    // Sort before formating value with currency
    lastItemData.packages = map(get(lastItemData, 'packages', []), pkg => ({
      ...pkg,
      value: formatAmountCurrency(pkg.value),
    }));
    data.push(lastItemData);

    // if the product kind is a loan insurance
    // then add TAEA data
    if (isLoanKind) {
      // add TAEA
      const taeas = getTaeaFromOffers(offers, loans, strings);
      taeas?.forEach(taea => data.push(taea));
    }
    /**
     * get Formulas
     * @param {} packages
     */
    const getFormulas = ({ packages }) => {
      try {
        // get formulas
        const formulas = map(packages, (packagesSortedItem, index) => {
          const packageItem = find(product?.packages, { code: get(packagesSortedItem, 'ref') });
          const formula = {
            code: get(packageItem, 'code'),
            value: get(packageItem, 'name'),
            prefix: 'Formule',
            description: get(packageItem, 'descriptions'),
            sequence: index,
            offerRef: packagesSortedItem?.offerRef,
          };
          return formula;
        });
        return formulas;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
      return [];
    };

    /**
     * get Formulas Recommended
     */
    const getFormulaRecommended = () => {
      try {
        const formulaRecommended = get(
          maxBy(packageEligible, item => get(item, 'score')),
          'package'
        );
        return formulaRecommended;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
      return undefined;
    };

    /**
     * get formulas
     */
    const formulas = getFormulas({ packages: packagesSorted });

    /**
     * Initialize the general structure
     */
    const dataOffer = {
      data,
      formulas,
      formulaRecommended: getFormulaRecommended(),
      extraData: {
        title: titlePart,
        codeProduct: product?.code,
        codeCommercialProduct,
      },
    };

    return dataOffer;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }

  return undefined;
};
